import React from "react";
import { useLazyLoadQuery, graphql } from "react-relay";

import { InversionSolutionDiagnosticContainerQuery } from "./__generated__/InversionSolutionDiagnosticContainerQuery.graphql";
import { SweepArguments } from "./generalTask.types";
import DiagnosticReportCard from "../../components/diagnosticReportCard/DiagnosticReportCard";

interface InversionSolutionDiagnosticContainerProps {
  readonly sweepArgs?: SweepArguments;
  modelType: string;
  ids?: string[];
  reportTab: number;
  setReportTab: (tab: number) => void;
}

const InversionSolutionDiagnosticContainer: React.FC<InversionSolutionDiagnosticContainerProps> = ({
  sweepArgs,
  modelType,
  ids,
  reportTab,
  setReportTab,
}: InversionSolutionDiagnosticContainerProps) => {
  const data = useLazyLoadQuery<InversionSolutionDiagnosticContainerQuery>(inversionSolutionDiagnosticContainerQuery, {
    ids: ids,
  });

  return (
    <>
      <DiagnosticReportCard
        inversionSolutions={data}
        sweepArgs={sweepArgs}
        modelType={modelType}
        reportTab={reportTab}
        setReportTab={setReportTab}
      />
    </>
  );
};

export default InversionSolutionDiagnosticContainer;

export const inversionSolutionDiagnosticContainerQuery = graphql`
  query InversionSolutionDiagnosticContainerQuery($ids: [ID!]) {
    nodes(id_in: $ids) {
      result {
        edges {
          node {
            __typename
            ... on Node {
              id
            }
            ... on FileInterface {
              file_name
              file_url
              file_size
              md5_digest
              meta {
                k
                v
              }
              relations {
                total_count
              }
            }
            ... on InversionSolutionInterface {
              created
              mfd_table {
                id
              }
              mfd_table_id
              tables {
                table_id
                table_type
              }
              produced_by {
                __typename
                ... on Node {
                  id
                }
                ... on AutomationTaskInterface {
                  parents {
                    edges {
                      node {
                        parent {
                          __typename
                          id
                          meta {
                            k
                            v
                          }
                          ... on Node {
                            id
                          }
                          ... on GeneralTask {
                            meta {
                              k
                              v
                            }
                            title
                            id
                            notes
                            description
                            created
                            model_type
                            swept_arguments
                            argument_lists {
                              k
                              v
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
